import { render, staticRenderFns } from "./walletCheckStatus.vue?vue&type=template&id=bf703bcc&scoped=true&"
import script from "./walletCheckStatus.vue?vue&type=script&lang=js&"
export * from "./walletCheckStatus.vue?vue&type=script&lang=js&"
import style0 from "./walletCheckStatus.vue?vue&type=style&index=0&id=bf703bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf703bcc",
  null
  
)

export default component.exports